import { TextareaHTMLAttributes, forwardRef } from "react";
import { clsx } from "clsx";

import { useFieldContext } from "./Field";

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  hasError?: boolean;
}

const baseClasses =
  "form-textarea mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-dobu-orange focus:ring-dobu-orange sm:text-sm";

const errorClasses = "border-red-500 focus:border-red-500 focus:ring-red-500";

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, hasError: hasErrorProp, id: idProp, ...props }, ref) => {
    const { hasError: hasErrorContext, id: idContext } = useFieldContext();
    const hasError = hasErrorProp ?? hasErrorContext ?? false;
    const id = idProp ?? idContext;

    return <textarea ref={ref} id={id} className={clsx(baseClasses, hasError && errorClasses, className)} {...props} />;
  },
);

TextArea.displayName = "TextArea";

export default TextArea;
